import React from 'react';
import T from 'components/common/translations/Translate';

export const InputForm = ({ handleChange, type, name, className, value, id }) => (
  <input
    id={id}
    type={type}
    name={name}
    className={`form__input ${className}`}
    value={value}
    onChange={handleChange} />
)

export const LabelForm = ({ id, text, className }) => (
  <label
    htmlFor={id}
    className={`form__label ${className}`}>
    <T>{text}</T>
  </label>
)

export const TextareaForm = ({ name, id, handleChange, className }) => (
  <textarea
    name={name}
    id={id}
    onChange={handleChange}
    className={`form__textarea ${className}`}>
  </textarea>
)

export const Error = ({ error, className, css }) => {
  if(!error){
    return null;
  }
  // {error.map((data) => `${data} `)}
  var msg = '';

  if(typeof error === "string" ){
    msg = error;
  } else {
    throw "Type of the error not handle"
  }

  return (
    <div className={"form__error"} style={css}>
      {msg}
    </div>
  )
}